import '../scss/slider.scss';
import './modules/image-gallery';
import './modules/logo-slider';
import './modules/caorusel';
import Splide from '@splidejs/splide';
import { Localize } from './modules/utilities/localize';

Splide.defaults = {
  i18n: {
    'prev': `${Localize('js.element.label.slider.prev', 'Previous')}`,
    'next': `${Localize('js.element.label.slider.next', 'Next')}`,
    'first': `${Localize('js.element.label.slider.first', 'First')}`,
    'last': `${Localize('js.element.label.slider.last', 'Next')}`,
    'slideX': `${Localize('js.element.label.slider.slideX', 'Slide')}`,
    'pageX': `${Localize('js.element.label.slider.pageX', 'Page')}`,
    'play': `${Localize('js.element.label.slider.play', 'Play')}`,
    'pause': `${Localize('js.element.label.slider.pause', 'Pause')}`,
    'carousel': `${Localize('js.element.label.slider.carousel', 'Carousel')}`,
    'select': `${Localize('js.element.label.slider.select', 'Select slide to show')}`,
    'slide': `${Localize('js.element.label.slider.slide', 'Slide')}`,
    'slideLabel': `${Localize('js.element.label.slider.slideLabel', 'Slide %s of %s')}`,
  }
}
